import React from "react";

import { Helmet } from "react-helmet";

/**
 * @see https://ogp.me/
 */

export interface Props {
  description?: string;
  keywords?: string;
  noFollow?: boolean;
  noIndex?: boolean;
  title?: string;
}

export const SEO: React.FC<Props> = ({
  description,
  keywords,
  noFollow = true,
  noIndex = true,
  title,
}) => {
  return (
    <Helmet>
      <meta charSet="utf-8" key="meta-charset" />
      <meta name="keywords" key="keywords" content={keywords || "Talentnet"} />
      <meta
        name="description"
        key="description"
        content={description || "Talentnet"}
      />
      <meta
        name="robots"
        content={`${noIndex ? "noindex" : "index"}, ${
          noFollow ? "nofollow" : "follow"
        }`}
      />
      <title key="title">{title || "Talentnet"}</title>
    </Helmet>
  );
};
